import React, { useMemo } from 'react';
import './App.css';
import Bio from './Bio';
import AppsAndSites from './AppsAndSites';
import Footer from './Footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEarthAmericas } from '@fortawesome/free-solid-svg-icons'
var mobile = require('is-mobile');

function App() {

  const isMobile: boolean = useMemo(() => {
    return mobile.isMobile({ featureDetect: true, tablet: true })
  }, [])

  return (
    <div className="App">
      <div style={{ height: 60, width: "100%", borderBottom: "1px solid black", alignItems: "center", justifyContent: "center" }}>{ }
        <h3 style={{ textAlign: "center", height: 40, fontSize: 30, marginRight: 20 }}>{"ALEX HARRISON"}</h3>
      </div>
      <div style={{ padding: 40 }}>
        <FontAwesomeIcon size={"4x"} icon={faEarthAmericas} />
        <h1>{"ABOUT"}</h1>
        <p style={{ fontSize: isMobile ? "16px" : "20px", textAlign: "left", marginBottom: 40, color: "#3f3f3f" }}>{Bio}</p>
        <img style={{ width: "50%", marginBottom: 40, minWidth: 300 }} src='./portrait.jpg' alt="Portrait of Alex Harrison" />
        <AppsAndSites />
      </div>
      <Footer />
    </div>
  );
}

export default App;
